/**
 * @generated SignedSource<<b805bae06e61074077fb552e41753d5a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_RepositoriesList$data = {
  readonly devOps: {
    readonly providers: {
      readonly devInfoProviders: ReadonlyArray<{
        readonly __typename: "DevOpsDevInfoProvider";
        readonly homeUrl: AGG$URL | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
    };
  };
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly repositories: {
        readonly edges: ReadonlyArray<{
          readonly lastUpdated: AGG$DateTime;
          readonly node: {
            readonly avatarUrl?: AGG$URL | null | undefined;
            readonly id?: string;
            readonly name?: string;
            readonly providerId?: string;
            readonly url?: AGG$URL;
          } | null | undefined;
        } | null | undefined>;
      };
    };
  };
  readonly " $fragmentType": "main_softwareCodePage_RepositoriesList";
};
export type main_softwareCodePage_RepositoriesList$key = {
  readonly " $data"?: main_softwareCodePage_RepositoriesList$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_RepositoriesList">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "projectKey"
    },
    {
      "kind": "RootArgument",
      "name": "siteAri"
    }
  ],
  "kind": "Fragment",
  "name": "main_softwareCodePage_RepositoriesList",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                },
                {
                  "kind": "Variable",
                  "name": "key",
                  "variableName": "projectKey"
                }
              ],
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "sort",
                        "value": {
                          "lastModified": {
                            "direction": "DESC",
                            "priority": 1
                          }
                        }
                      }
                    ],
                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                    "kind": "LinkedField",
                    "name": "repositories",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "kind": "ScalarField",
                                "name": "lastUpdated"
                              },
                              "action": "THROW",
                              "path": "jira.jiraProjectByKey.repositories.edges.lastUpdated"
                            },
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v0/*: any*/),
                                      "action": "THROW",
                                      "path": "jira.jiraProjectByKey.repositories.edges.node.id"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "kind": "ScalarField",
                                        "name": "providerId"
                                      },
                                      "action": "THROW",
                                      "path": "jira.jiraProjectByKey.repositories.edges.node.providerId"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v1/*: any*/),
                                      "action": "THROW",
                                      "path": "jira.jiraProjectByKey.repositories.edges.node.name"
                                    },
                                    {
                                      "kind": "ScalarField",
                                      "name": "avatarUrl"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "kind": "ScalarField",
                                        "name": "url"
                                      },
                                      "action": "THROW",
                                      "path": "jira.jiraProjectByKey.repositories.edges.node.url"
                                    }
                                  ],
                                  "type": "DevOpsRepository"
                                }
                              ]
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.jiraProjectByKey.repositories.edges"
                      }
                    ],
                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                  },
                  "action": "THROW",
                  "path": "jira.jiraProjectByKey.repositories"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.jiraProjectByKey"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "id",
                  "variableName": "siteAri"
                },
                {
                  "kind": "Literal",
                  "name": "providerTypes",
                  "value": [
                    "DEV_INFO"
                  ]
                }
              ],
              "concreteType": "DevOpsProviders",
              "kind": "LinkedField",
              "name": "providers",
              "plural": false,
              "selections": [
                {
                  "concreteType": "DevOpsDevInfoProvider",
                  "kind": "LinkedField",
                  "name": "devInfoProviders",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    {
                      "kind": "RequiredField",
                      "field": (v0/*: any*/),
                      "action": "THROW",
                      "path": "devOps.providers.devInfoProviders.id"
                    },
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "homeUrl"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "devOps.providers"
          }
        ]
      },
      "action": "THROW",
      "path": "devOps"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "d2352d7812476683a194fac5c19877c6";

export default node;
